<template>
  <v-flex>
    <v-container>
      <v-card class="mx-auto pl-4" min-width="100%">
        <!-- Headline section start-->
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline font-weight-bold">
              Subscription
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="loading">
          <v-card-text>
            Now loading...
            <v-progress-linear
              indeterminate
              color="primary"
              class="mb-10"
            ></v-progress-linear>
          </v-card-text>
        </template>
        <template v-else>
          <!-- Current Plan section start-->
          <v-list-item>
            <v-list-item-content>
              <v-form ref="form" @submit.prevent>
                <v-row>
                  <v-col cols="3" class="d-flex align-center">
                    Current Plan
                  </v-col>
                  <template
                    v-if="
                      myPlan.PaymentStatus === 'na' ||
                        myPlan.PaymentStatus === 'complete'
                    "
                  >
                    <v-col cols="4" class="d-flex align-center">
                      <v-text-field
                        filled
                        dense
                        outlined
                        readonly
                        name="current_plan"
                        :value="myPlan ? myPlan.CurrentPlan : ''"
                        :hide-details="true"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                      <v-btn
                        color="success"
                        @click.stop="setChangePlanDialog(true)"
                      >
                        Change Plan
                      </v-btn>
                    </v-col>
                  </template>
                  <template v-if="myPlan.PaymentStatus === 'processing'">
                    <v-col cols="8" class="d-flex align-center">
                      <v-progress-circular
                        class="ml-3 mr-3"
                        indeterminate
                        color="primary"
                      />
                      Now processing...
                    </v-col>
                  </template>
                  <template v-if="myPlan.PaymentStatus === 'failure'">
                    <v-col cols="4" class="red--text d-flex align-center">
                      Payment failed. Please check your email.
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                      <v-btn
                        color="success"
                        @click.stop="setChangePlanDialog(true)"
                      >
                        Change Plan
                      </v-btn>
                    </v-col>
                  </template>
                </v-row>
              </v-form>
            </v-list-item-content>
          </v-list-item>

          <!-- Monthly limit section start-->
          <v-list-item>
            <v-list-item-content>
              <v-row>
                <v-col cols="3" class="d-flex align-center">
                  Monthly upload
                </v-col>
                <v-col cols="4" class="d-flex align-center">
                  <div class="mb-2">
                    <span style="font-size: 30px">
                      {{ myPlan.ThisMonthUploads }}
                    </span>
                    <span style="font-size: 22px">
                      {{ ' / ' + myPlan.UploadQuota }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="3" class="d-flex align-center">
                  have been used
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" class="d-flex align-center">
                  Notebook tasks
                </v-col>
                <v-col cols="4" class="d-flex align-center">
                  <div class="mb-2">
                    <span style="font-size: 30px">
                      {{ myPlan.ThisMonthNotebooks }}
                    </span>
                    <span style="font-size: 22px">
                      {{ ' / ' + myPlan.NotebooksQuota }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="3" class="d-flex align-center">
                  have been used
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" class="d-flex align-center">Tokens</v-col>
                <template
                  v-if="
                    myPlan.TokenPaymentStatus === 'na' ||
                      myPlan.TokenPaymentStatus === 'complete'
                  "
                >
                  <v-col cols="4" class="d-flex align-center">
                    <div class="mb-2">
                      <span style="font-size: 30px">
                        {{ myPlan.Tokens }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="3" class="d-flex align-center">
                    <v-btn
                      color="success"
                      @click.stop="setPurchaseTokenDialog(true)"
                      :disabled="myPlan.CurrentPlan === 'Free'"
                    >
                      Purchase
                    </v-btn>
                  </v-col>
                </template>
                <template v-if="myPlan.TokenPaymentStatus === 'processing'">
                  <v-col cols="8" class="d-flex align-center">
                    <v-progress-circular
                      class="ml-3 mr-3"
                      indeterminate
                      color="primary"
                    />
                    Now processing...
                  </v-col>
                </template>
                <template v-if="myPlan.TokenPaymentStatus === 'failure'">
                  <v-col cols="4" class="red--text d-flex align-center">
                    Payment error: Please check your credit card again.
                  </v-col>
                  <v-col cols="3" class="d-flex align-center">
                    <v-btn
                      color="success"
                      @click.stop="setPurchaseTokenDialog(true)"
                    >
                      Purchase
                    </v-btn>
                  </v-col>
                </template>
              </v-row>
              <v-row>
                <v-col cols="3" class="d-flex align-center">
                  Notebook tokens
                </v-col>
                <v-col cols="4" class="d-flex align-center">
                  <div class="mb-2">
                    <span style="font-size: 30px">
                      {{ myPlan.NotebookTokens }}
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>

          <!-- invoice section start-->
          <v-list-item three-line>
            <v-list-item-content>
              <v-form @submit.prevent>
                <v-row>
                  <v-col cols="3" class="d-flex align-center">Receipts</v-col>
                  <v-col cols="4" class="d-flex align-center">
                    <v-select
                      v-model="selectedInvoiceUrl"
                      :items="invoices"
                      item-text="Created"
                      item-value="HostedInvoiceUrl"
                      label="Select"
                      dense
                      outlined
                      name="invoiceChoices"
                      :hide-details="true"
                    ></v-select>
                  </v-col>
                  <v-col cols="3" class="d-flex align-center">
                    <v-btn
                      :href="selectedInvoiceUrl"
                      target="_blank"
                      rel="noopener"
                      color="primary"
                      :disabled="!this.selectedInvoiceUrl"
                    >
                      View receipt
                    </v-btn>
                    <!-- <div v-if="downloadWaiting">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                    <div v-else>
                      <v-btn
                        v-if="this.selectedInvoiceId"
                        color="primary"
                        @click="download()"
                      >
                        Download
                      </v-btn>
                      <v-btn v-else disabled>
                        Download
                      </v-btn>
                    </div> -->
                  </v-col>
                </v-row>
              </v-form>
            </v-list-item-content>
          </v-list-item>

          <!-- Credit card info section start-->
          <v-list-item>
            <v-list-item-content>
              <v-form ref="form" @submit.prevent>
                <v-row>
                  <v-col cols="3" class="d-flex align-center">
                    Credit card info
                  </v-col>
                  <v-col cols="4" class="d-flex align-center">
                    <v-text-field
                      v-if="this.myPlan && this.myPlan.LastFour"
                      filled
                      outlined
                      dense
                      readonly
                      name="credit_card"
                      :hide-details="true"
                      :value="
                        this.myPlan.LastFour === 'not-registered'
                          ? 'not registered'
                          : '**** **** **** ' + this.myPlan.LastFour
                      "
                    ></v-text-field>
                    <v-text-field
                      v-else
                      filled
                      outlined
                      dense
                      disabled
                      name="credit_card"
                      value="Not registered"
                      :hide-details="true"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="d-flex align-center">
                    <v-btn
                      @click.stop="setRegisterCreditCardDialog(true)"
                      color="success"
                    >
                      Register credit card
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-list-item-content>
          </v-list-item>

          <!-- Team info section start-->
          <v-list-item>
            <v-list-item-content>
              <v-form ref="form" @submit.prevent>
                <v-row>
                  <v-col cols="3" class="d-flex align-center">Team</v-col>
                  <v-col cols="4" class="d-flex align-center">
                    <v-text-field
                      v-if="this.team"
                      :filled="!this.team.TeamId"
                      outlined
                      dense
                      readonly
                      name="team_name"
                      :hide-details="true"
                      :value="team.TeamName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="d-flex align-center">
                    <v-btn
                      @click.stop="setCreateTeamDialog(true)"
                      color="success"
                      :disabled="
                        myPlan.CurrentPlan !== 'Premium' ||
                          !is_empty(team.TeamId)
                      "
                    >
                      Create a team
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="d-flex align-center"></v-col>
                  <v-col cols="4" class="d-flex align-center"></v-col>
                  <v-col cols="3" class="d-flex align-center">
                    <v-btn
                      @click.stop="setAddTeamMemberDialog(true)"
                      color="success"
                      :disabled="is_empty(team.TeamId)"
                    >
                      View members
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-card>
    </v-container>

    <!-- Change Plan dialog -->
    <template v-show="changePlanDialog">
      <change-plan-dialog
        v-if="plans && myPlan && team"
        :plans="plans"
        :myPlan="myPlan"
        :team="team"
        :changePlanDialog="changePlanDialog"
        @init="init"
        @setChangePlanDialog="setChangePlanDialog"
      ></change-plan-dialog>
    </template>

    <!-- Purchase Token dialog -->
    <template v-show="purchaseTokenDialog">
      <purchase-token-dialog
        v-if="myPlan && tokenPlans"
        :myPlan="myPlan"
        :tokenPlans="tokenPlans"
        :purchaseTokenDialog="purchaseTokenDialog"
        @init="init"
        @setPurchaseTokenDialog="setPurchaseTokenDialog"
      ></purchase-token-dialog>
    </template>

    <!-- Register Credit card dialog -->
    <template v-show="registerCreditCardDialog">
      <register-credit-card-dialog
        :registerCreditCardDialog="registerCreditCardDialog"
        @init="init"
        @setRegisterCreditCardDialog="setRegisterCreditCardDialog"
      ></register-credit-card-dialog>
    </template>

    <!-- Create Team dialog -->
    <template v-show="createTeamDialog">
      <create-team-dialog
        :createTeamDialog="createTeamDialog"
        @init="init"
        @setCreateTeamDialog="setCreateTeamDialog"
      ></create-team-dialog>
    </template>

    <!-- Add Team member dialog -->
    <template v-show="addTeamMemberDialog">
      <add-team-member-dialog
        v-if="myPlan && team"
        :addTeamMemberDialog="addTeamMemberDialog"
        :team="team"
        :myPlan="myPlan"
        @init="init"
        @setAddTeamMemberDialog="setAddTeamMemberDialog"
        @reloadTeamInfo="reloadTeamInfo"
      ></add-team-member-dialog>
    </template>
  </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import RegisterCreditCardDialog from '@/components/account/RegisterCreditCardDialog.vue'
import ChangePlanDialog from '@/components/account/ChangePlanDialog.vue'
import PurchaseTokenDialog from '@/components/account/PurchaseTokenDialog.vue'
import CreateTeamDialog from '@/components/account/CreateTeamDialog.vue'
import AddTeamMemberDialog from '@/components/account/AddTeamMemberDialog.vue'

export default {
  name: 'Subscription',
  title: 'subscription',
  components: {
    RegisterCreditCardDialog,
    ChangePlanDialog,
    PurchaseTokenDialog,
    CreateTeamDialog,
    AddTeamMemberDialog,
  },
  data: () => ({
    changePlanDialog: false,
    purchaseTokenDialog: false,
    downloadWaiting: false,
    loading: true,
    registerCreditCardDialog: false,
    createTeamDialog: false,
    addTeamMemberDialog: false,
    invoices: [],
    selectedInvoiceUrl: null,
    myPlan: null,
    plans: null,
    tokenPlans: null,
    team: null,
  }),
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    // Download a invoice PDF is deprecated.
    // async download() {
    //   this.downloadWaiting = true
    //   const invoice = await this.getInvoice(this.selectedInvoiceId)
    //   if (!invoice) {
    //     this.downloadWaiting = false
    //     return
    //   }
    //   const link = document.createElement('a')
    //   link.href = invoice.data.InvoicePDF
    //   link.click()
    //   this.downloadWaiting = false
    // },
    async init() {
      Object.assign(this.$data, this.$options.data())
      this.loading = true
      const result = await Promise.all([
        this.getPlans(),
        this.getMyPlan(),
        this.getInvoices(),
        this.getTokenPlans(),
        this.getTeam(),
      ])
      if (!result[0] || !result[1] || !result[2] || !result[3] || !result[4]) {
        this.page_to({path: '/'})
      }
      this.plans = result[0].data
      this.myPlan = result[1].data
      if (this.myPlan.CurrentPlan) {
        this.myPlan.CurrentPlan = this.ucfirst(this.myPlan.CurrentPlan)
      }
      this.invoices = result[2].data
      this.tokenPlans = result[3].data
      this.team = result[4].data
      if (this.invoices.length) {
        this.selectedInvoiceUrl = this.invoices[0].HostedInvoiceUrl
      }
      this.loading = false
      if (this.myPlan.PaymentStatus === 'processing') {
        this.$_watchStatus('payment', 5000)
      }
      if (this.myPlan.TokenPaymentStatus === 'processing') {
        this.$_watchStatus('token', 1000)
      }
    },
    async reloadTeamInfo() {
      const result = await this.getTeam()
      this.team = result.data
    },
    setChangePlanDialog(show) {
      this.changePlanDialog = show
    },
    setPurchaseTokenDialog(show) {
      this.purchaseTokenDialog = show
    },
    setRegisterCreditCardDialog(show) {
      this.registerCreditCardDialog = show
    },
    setAddTeamMemberDialog(show) {
      this.addTeamMemberDialog = show
    },
    setCreateTeamDialog(show) {
      this.createTeamDialog = show
    },
    $_watchStatus(kind, timing) {
      let count = 0
      const watch = setInterval(
        async function() {
          const result = await this.getMyPlan()
          this.myPlan = result.data
          if (
            (kind === 'payment' &&
              this.myPlan.PaymentStatus === 'processing') ||
            (kind === 'token' &&
              this.myPlan.TokenPaymentStatus === 'processing')
          ) {
            // continue to watch the status.
            count++
            if (count >= 30) {
              clearInterval(watch)
            }
          } else {
            clearInterval(watch)
          }
        }.bind(this),
        timing
      )
    },
  },
  mounted() {
    if (!this.is_empty(this.$route.query)) {
      this.$router.replace({path: '/account/subscription'})
    }
    this.init()
  },
}
</script>
